export default __webpack_public_path__ + "static/media/homebanner2.fd064225.jpg";